import { Injectable, signal } from '@angular/core';
import { Subject } from 'rxjs';
import { VentasSidebarMode } from '../models/ventas.model';

export interface VentasContextItem {
  id: string;
  label: string;
  icon: string;
  danger?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class VentasSidebarService {
  /** Current sidebar mode driven by VentasPage */
  private _mode = signal<VentasSidebarMode>('salon');
  readonly mode = this._mode.asReadonly();

  /** Active item id */
  private _activeItem = signal<string>('por-salon');
  readonly activeItem = this._activeItem.asReadonly();

  /** Context items shown below navigation (mesa/pago items) */
  private _contextItems = signal<VentasContextItem[]>([]);
  readonly contextItems = this._contextItems.asReadonly();

  /** Whether the ventas module is currently active */
  private _isVentasActive = signal(false);
  readonly isVentasActive = this._isVentasActive.asReadonly();

  /** Subject for context item clicks (mesa: editar-mesa, dividir-cuentas, etc.) */
  contextItemClick$ = new Subject<string>();

  /** Subject for close pago button */
  closePago$ = new Subject<void>();

  /** Subject for volver button */
  volverClick$ = new Subject<void>();

  /** Subject for anular venta button */
  anularVentaClick$ = new Subject<void>();

  setMode(mode: VentasSidebarMode): void {
    this._mode.set(mode);
    this._contextItems.set(this.getItemsForMode(mode));
  }

  setActiveItem(id: string): void {
    this._activeItem.set(id);
  }

  setVentasActive(active: boolean): void {
    this._isVentasActive.set(active);
    if (!active) {
      this._mode.set('salon');
      this._contextItems.set([]);
    }
  }

  private getItemsForMode(mode: VentasSidebarMode): VentasContextItem[] {
    if (mode === 'mesa') {
      return [
        { id: 'editar-mesa', label: 'Editar mesa', icon: 'edit' },
        { id: 'dividir-cuentas', label: 'Dividir Cuentas', icon: 'scissors' },
        { id: 'unir-mesa', label: 'Unir mesa', icon: 'link' },
        { id: 'mover-pedido', label: 'Mover Pedido', icon: 'move' },
      ];
    }
    if (mode === 'pago') {
      return [
        { id: 'transferencia', label: 'Transferencia', icon: 'transfer' },
        { id: 'agregar-descuentos', label: 'Agregar descuentos', icon: 'discount' },
      ];
    }
    return [];
  }
}
